// extracted by mini-css-extract-plugin
export default {"otp_inp":"styles_otp_inp__+6OIo","inp_focus":"styles_inp_focus__85WMo","otp_container":"styles_otp_container__+BtsH"};